import React, { Component } from 'react';
import EdiText from 'react-editext';
import '../../content/css/EditableTextField.css';

export default class EditableTextField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            text: props.text
        };

        this.handleSave = this.handleSave.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        var self = this;
        if (prevProps.text !== this.props.text) this.setState({ text: self.props.text });
    }

    handleSave = val => {
        this.setState({ text: val });
        this.props.onChange(val);
    }

    render() {
        return (
            <EdiText
                showButtonsOnHover
                type='text'
                value={this.state.text}
                editButtonClassName="editable-text-field-btn"
                viewProps={this.props.viewProps}
                onSave={this.handleSave}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/EditableTextField.js